import { BLEND_MODES, Point } from "pixi.js";
import { PREngineController } from "./PREngineController";
import { PunkSymbol } from "./symbol/PunkSymbol";
import { ReelGameData } from "../server/data/GameDataModels";
import { ReelEngineManager } from "../../core/reel/ReelEngineManager";
import { IReelConfig } from "../../core/reel/IData/IReelData";
import { Helper } from "../../core/utils/Helper";
import { IDimOrientation, LayoutDimData, ResizeHelper } from "../../core/utils/ResizeHelper";
import { PunkSymbolData } from "./symbol/PunkSymbolData";
import { Sequence } from "../../core/displayobject/Sequence";
import { PunkRocker } from "../PunkRocker";
import { MathHelper } from "../../core/utils/MathHelper";
import { gsap } from 'gsap';
import {GameConfig} from "../config/base/GameConfig";

export class PREngineManager extends ReelEngineManager {

    private static timelineIntro: gsap.core.Timeline;
    private bottomTrainVisible: boolean = false;

    protected static readonly reelDim: IDimOrientation = {
        landscape: {
            scale: new Point(1, 1),
            position: new Point(16, 210)
        },
        portrait: {
            scale: new Point(1, 1),
            position: new Point(16, 210)
        }
    };

    protected static readonly reelDimScaled: IDimOrientation = {
        landscape: {
            scale: new Point(GameConfig.GLOBAL_SCALING_SFS, GameConfig.GLOBAL_SCALING_SFS),
            position: new Point(46, 194)
        },
        portrait: {
            scale: new Point(GameConfig.GLOBAL_SCALING_MG_FS, GameConfig.GLOBAL_SCALING_MG_FS),
            position: new Point(16, 210)
        }
    };

    private maskObj: PIXI.Graphics;

    constructor(reelAmount: number, config: IReelConfig, initData: any, juri_time_calc: (value: number) => number) {
        super(reelAmount, config, initData, juri_time_calc);
        this.name = "PREngineManager";

        this.onResize();
    }

    protected init(amount: number, initData: any): void {
        super.init(amount, initData);

        this.maskObj = this.createGraphic(undefined,undefined);
        this.maskObj.name = "mask";
        this.maskObj.visible = false;

        //#8 pt.2
        //PREngineManager.getReel(PREngineManager.AllReels.length-1).isActive = false;
    }

    public onResize(): void {
        super.onResize();
        const scaledReelDim: LayoutDimData = this.bottomTrainVisible ? PREngineManager.dimScaled: PREngineManager.dim;
        this.position.set(scaledReelDim.position.x, scaledReelDim.position.y);
        this.scale.set(scaledReelDim.scale.x, scaledReelDim.scale.y);
    }

    public onBottomTrainShow(flag: boolean): void {
        this.bottomTrainVisible = flag;
        const scaledReelDim: LayoutDimData = flag ? this.dimScaled : this.dim;

        if (flag) {
            gsap.to(this.position, {
                x: scaledReelDim.position.x,
                y: scaledReelDim.position.y,
                duration: GameConfig.FRAME_EXPAND_DUR
            });
            gsap.to(this.scale, {
                x: scaledReelDim.scale.x,
                y: scaledReelDim.scale.y,
                duration: GameConfig.FRAME_EXPAND_DUR
            });
        } else {
            this.position.set(scaledReelDim.position.x, scaledReelDim.position.y);
            this.scale.set(scaledReelDim.scale.x, scaledReelDim.scale.y);
        }
    }

    protected createGraphic(color: number = 0x000000, alpha: number = 1): PIXI.Graphics {

        const w: number = 115 * this.AllReels.length;
        const h: number = 540;
        const hOffset: number = h/this.reelConfig.WINDOW_AMOUNT;
        const ms: PIXI.Graphics = new PIXI.Graphics();
        ms.beginFill(color, 0.5);
        ms.drawRect(-1, -hOffset/2, (w + 2), h);
        ms.endFill();
        this.addChild(ms);
        return ms;
    }
    

    private boxes:Sequence[] = [];
    private tlBoxFlash: gsap.core.Timeline;
    public flashBoxes(amm:number = 3): void {

        this.boxes = [];
        this.tlBoxFlash = Helper.setTimeline(this.tlBoxFlash,undefined,true);
        const symHeight = PunkSymbolData.fetchSymSize(7-amm);
        const symHeightoffset = (PunkSymbolData.fetchSymSize(4) - symHeight)/2;
        const symTimesHeight = PunkSymbolData.fetchSizeTimesSize(7-amm);

        for(let r = 0; r <  this.AllReels.length; r++){
            for(let i= 0; i < amm; i++){
                const b = this.addChild(Sequence.createSequence(PunkRocker.assetLoader.getTextures("Sector_Attention")));
                b.blendMode = BLEND_MODES.ADD;
                b.position.set(this.AllReels[r].position.x, symHeight*i);
                b.scale.y = symTimesHeight;
                b.position.y -= symHeightoffset;
                this.boxes.push(b);
            }
        }

        this.boxes.forEach((b,i) => {
            const row = i%amm;
            this.tlBoxFlash.fromTo(b,{alpha:0},{alpha:1,duration:0.2},row*0.1);
        })
        const totDurr = this.tlBoxFlash.duration();
        this.boxes.forEach((b,i) => {
            const row = i%amm;
            this.tlBoxFlash.to(b,{alpha:0,duration:0.2},totDurr+row*0.1);
        })

        this.tlBoxFlash.add(()=>{
            this.boxes.forEach(s => s.destroy())
            this.boxes = [];
        })
    }

    public get dim(): LayoutDimData { return PREngineManager.dim; };
    public get dimScaled(): LayoutDimData { return PREngineManager.dimScaled; };
    public static get dim(): LayoutDimData { return ResizeHelper.calcDim(this.reelDim); };
    public static get dimScaled(): LayoutDimData { return ResizeHelper.calcDim(this.reelDimScaled); };

    public static getReel(ID: number): PREngineController { return <PREngineController>super.getReel(ID); };
    public static get AllReels(): PREngineController[] { return <PREngineController[]>this._reels; };
    public get AllReels(): PREngineController[] { return <PREngineController[]>ReelEngineManager.AllReels; };

    public static RSWindow(func: (rc: PREngineController, sym: PunkSymbol) => void): void {
        this.RAll((rc: PREngineController) => {
            for (let symID: number = 0; symID < rc.AllWindowSymbols.length; symID++)
                func(rc, rc.AllWindowSymbols[symID]);
        });
    };

    public static RSAll(func: (rc: PREngineController, sym: PunkSymbol) => void): void {
        this.RAll((rc: PREngineController) => {
            for (let row: number = 0; row < rc.AllSymbols.length; row++)
                func(rc, rc.AllSymbols[row]);
        });
    };

    public static RAll(func: (rc: PREngineController) => void): void {
        for (let reel: number = 0; reel < this.AllReels.length; reel++) {
            func(this.AllReels[reel]);
        }
    };

    protected createReel(ID: number, initData: ReelGameData): PREngineController {
        return new PREngineController(ID, this.reelConfig, initData);
    }

    public getSymPos(ReelID: number,SymID:number): PIXI.Point {
         return MathHelper.pointAdd(this.position, PREngineManager.getReel(ReelID).symPos(SymID));
    };

    applyMask(val: boolean): void {
        this.mask = val ? this.maskObj : undefined!;
        this.maskObj.visible = val;
    }
    
    // public static introPlay(): gsap.core.Timeline {
    //     this.timelineIntro = Helper.setTimeline();

    //     let yTo: number[] = ArrayHelper.initArrayWithValues(this.AllReels.length, (i) => {
    //         return this.AllReels[i].y;
    //     })

    //     for (let i = 0; i < this.AllReels.length; i++) {
    //         this.timelineIntro.fromTo(this.AllReels[i], { y: yTo[i] + 1280 }, {y: yTo[i], duration: 1.25, ease: Back.easeOut.config(1.13) }, i * 0.1);
    //         this.timelineIntro.fromTo(this.AllReels[i], { alpha: 0 }, { alpha: 1, duration: 0.5 }, i * 0.05);
    //     }

    //     let endDurr:number = 1.25 + (this.AllReels.length-1)*0.1;
    //     for (let i = 0; i < this.AllReels.length; i++) {
    //         this.timelineIntro.fromTo(this.AllReels[i].scale, { x:0.8,y:0.8 }, { x:1,y:1, duration: 0.5, ease: Back.easeIn.config(3) },endDurr);
    //         this.timelineIntro.add(() => {this.AllReels[i].flashReelGFX()},endDurr+0.5)
    //     }

    //     return this.timelineIntro;
    // }
}